<div class="row g-3">
  <div 
    [class.col-md-6]="renewalFrequency !== ComplianceRenewalFrequency.Never"
    [class.col-12]="renewalFrequency === ComplianceRenewalFrequency.Never"
  >
    <dx-date-box
      [value]="startDate"
      (onValueChanged)="onStartDateChange($event)"
      [label]="'COMMON.FIELDS.FROM-DATE' | translate"
      [readOnly]="readOnly"
      labelMode="floating"
      stylingMode="outlined"
      displayFormat="d MMMM yyyy"
      type="date"
    >
      <dx-validator #startDateValidator>
        <dxi-validation-rule 
          type="required" 
          [message]="'VALIDATIONS.START-DATE-REQUIRED' | translate"
        ></dxi-validation-rule>
      </dx-validator>
    </dx-date-box>
  </div>

  @if(renewalFrequency !== ComplianceRenewalFrequency.Never) {
    <div class="col-md-6">
      <dx-date-box
        [value]="endDate"
        [label]="'COMMON.FIELDS.TO-DATE' | translate"
        [readOnly]="true"
        labelMode="floating"
        stylingMode="outlined"
        displayFormat="d MMMM yyyy"
        type="date"
      >
       <dx-validator #endDateValidator>
        <dxi-validation-rule 
          type="required" 
          [message]="'VALIDATIONS.DATE-REQUIRED' | translate"
        ></dxi-validation-rule>
      </dx-validator>
      </dx-date-box>
    </div>
  }
</div>
